import { getHttp } from '@/api/httpFactory';
import { API_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_BASE_URL, true);

const addressApi = {
    /**
     * Get all address
     * @returns {Promise<Object>} Response containing address data
     */
    async fetchAddress() {
        const resp = await http.get(API_URLS.ADDRESS.GET);

        return resp;
    },

    /**
     * Get address by zipcode
     * @param {Object} payload Request payload
     * @returns {Promise<Object>} Response containing address data
     */
    async fetchByZipcode(payload) {
        const resp = await http.get(API_URLS.ADDRESS.ZIPCODE, payload);

        return resp;
    },
};

export default addressApi;
